<template>
  <div class="order-query-page">
    <!-- Header -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo" @click="goHome">
          <span class="logo-text">51软件下载</span>
        </div>
        <el-menu 
          mode="horizontal" 
          class="nav-menu" 
          background-color="transparent" 
          text-color="#1890ff"
          active-text-color="#1890ff"
          :default-active="activeMenu"
          @select="handleMenuSelect"
          :ellipsis="false"
        >
          <el-menu-item  @click="goHome" :style="{ color: '#666' }">首页</el-menu-item>
          <el-menu-item index="/order-query" :style="{ color: '#666' }">订单查询</el-menu-item>
          <el-menu-item index="/feedback" :style="{ color: '#666' }">意见反馈</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- Hero Section -->
    <div class="hero-section">
      <div class="container">
        <div class="hero-content">
          <div class="hero-text">
            <h1>订单查询</h1>
            <div class="lead">输入您的手机号，快速查询订单信息、支付状态和商品详情</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="query-section">
      <div class="query-container">
        <div class="query-header">
          <h2>快速查询您的订单</h2>
          <p>输入手机号码查看订单状态和商品信息</p>
        </div>
        <el-form :model="queryForm" class="query-form">
          <el-form-item>
            <el-input 
              v-model="queryForm.tel" 
              placeholder="请输入手机号" 
              clearable
              size="large"
              class="tel-input"
            >
              <template #prefix>
                <el-icon><Phone /></el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button 
              type="primary" 
              size="large"
              @click="handleQuery"
              :loading="loading"
              class="query-btn"
            >
              <el-icon><Search /></el-icon>
              查询订单
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="result-section" v-if="resultList.length > 0">
      <div class="result-header">
        <h2>查询结果</h2>
        <span class="result-count">共 {{ pagination.total }} 条订单</span>
      </div>
      <el-table 
        :data="resultList" 
        style="width: 100%" 
        stripe
        v-loading="loading"
        class="order-table"
      >
        <el-table-column prop="tradeNo" label="订单号" width="180">
          <template #default="scope">
            <span class="trade-no">{{ scope.row.tradeNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tel" label="手机号" width="120" />
        <el-table-column prop="game" label="商品名称" width="180" />
        <el-table-column prop="price" label="金额" width="100">
          <template #default="scope">
            <span class="price">¥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="150" align="center">
          <template #default="scope">
            <el-tag 
              :type="scope.row.status.includes('支付成功') ? 'success' : scope.row.status.includes('待支付') ? 'warning' : 'info'"
              effect="light"
            >
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" />
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template #default="scope">
            <el-button 
              size="small" 
              type="primary" 
              text
              @click="openInstallGuide(scope.row.games)"
              v-if="scope.row.games && scope.row.games.length > 0"
            >
              安装指南
            </el-button>
            <el-divider direction="vertical" v-if="scope.row.games && scope.row.games.length > 0" />
            <el-button 
              size="small" 
              type="primary" 
              text
              @click="viewGames(scope.row.games)"
            >
              查看商品
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-wrapper" v-if="pagination.total > 0">
        <el-pagination
          v-model:current-page="pagination.page"
          v-model:page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <div class="no-data" v-else-if="queryExecuted && resultList.length === 0">
      <el-empty 
        description="暂无订单数据" 
        :image-size="100"
      >
        <template #default>
          <p>未找到相关订单，请检查手机号是否正确</p>
          <el-button type="primary" @click="queryForm.tel = ''" style="margin-top: 10px;">返回重新查询</el-button>
        </template>
      </el-empty>
    </div>

    <!-- 商品详情对话框 -->
    <el-dialog
      v-model="dialogVisible"
      title="商品详情"
      width="600"
    >
      <el-table :data="currentGames" style="width: 100%">
        <el-table-column prop="name" label="商品名称" />
        <el-table-column label="操作" width="120">
          <template #default="scope">
            <el-button 
              size="small" 
              type="primary" 
              @click="openGuide(scope.row.installationGuide)"
            >
              安装指南
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 客服联系方式 -->
    <div class="customer-service">
      <div class="service-toggle" @click="toggleServicePanel">
        <el-icon><Service /></el-icon>
        <span>{{ isServicePanelOpen ? '收起客服' : '联系客服' }}</span>
      </div>
      <div class="service-content" :class="{ 'expanded': isServicePanelOpen }">
        <div class="service-header">
          <span>客服咨询</span>
        </div>
        <div class="service-body">
          <!-- <div class="qrcode-container">
            <img src="../assets/wechat.png" alt="企业微信二维码" class="qrcode-img">
          </div> -->
          <div class="service-info">
            <!-- <p>企业微信</p> -->
            <a href="https://work.weixin.qq.com/kfid/kfc8d0f9bc2d1044192" target="_blank" class="service-link">
              点击联系客服
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getTransactionListByTel } from '@/utils/api'
import { ElMessage } from 'element-plus'
import {
  Service,
  Phone,
  Search
} from '@element-plus/icons-vue'

// 路由相关
const route = useRoute()
const router = useRouter()

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  if (route.path === '/order-query') {
    return '/order-query'
  } else if (route.path === '/feedback') {
    return '/feedback'
  } else if (route.path === '/idm') {
    return '/idm'
  }
  return '/'
})

// 菜单选择处理
const handleMenuSelect = (key) => {
  if (key === '/') {
    goHome()
  } else if (key === '/idm') {
    router.push('/idm')
  } else if (key === '/order-query') {
    router.push('/order-query')
  } else if (key === '/feedback') {
    router.push('/feedback')
  }
}

// 返回首页 - 尝试从历史记录回退，如果不存在则跳转到 /
const goHome = () => {
  // 尝试回退到前一个页面
  if (window.history.length > 1) {
    router.back()
  } else {
    // 如果历史记录为空，直接跳转到首页
    router.push('/')
  }
}

// 查询表单
const queryForm = reactive({
  tel: ''
})

// 结果列表
const resultList = ref([])

// 分页信息
const pagination = reactive({
  page: 1,
  pageSize: 100,
  total: 0
})

// 加载状态
const loading = ref(false)

// 查询是否已执行
const queryExecuted = ref(false)

// 对话框相关
const dialogVisible = ref(false)
const currentGames = ref([])

// 查询订单
const handleQuery = async () => {
  if (!queryForm.tel) {
    ElMessage.warning('请输入手机号')
    return
  }
  
  // 验证手机号格式
  const telRegex = /^1[3-9]\d{9}$/
  if (!telRegex.test(queryForm.tel)) {
    ElMessage.warning('请输入正确的手机号格式')
    return
  }
  
  loading.value = true
  try {
    const result = await getTransactionListByTel(queryForm.tel)
    if (result.code === 0) {
      resultList.value = result.data.list || []
      pagination.total = result.data.total || 0
      queryExecuted.value = true
    } else {
      ElMessage.error(result.msg || '查询失败')
      resultList.value = []
    }
  } catch (error) {
    ElMessage.error('查询失败: ' + error.message)
    resultList.value = []
  } finally {
    loading.value = false
  }
}

// 查看商品详情
const viewGames = (games) => {
  currentGames.value = games
  dialogVisible.value = true
}

// 打开第一个商品的安装指南
const openInstallGuide = (games) => {
  if (games && games.length > 0) {
    const firstGame = games[0]
    if (firstGame.installationGuide) {
      openGuide(firstGame.installationGuide)
    } else {
      ElMessage.warning('暂无安装指南')
    }
  } else {
    ElMessage.warning('暂无商品信息')
  }
}

// 打开安装指南
const openGuide = (url) => {
  if (url) {
    window.open(url, '_blank')
  } else {
    ElMessage.warning('暂无安装指南')
  }
}

// 分页相关
const handleSizeChange = (val) => {
  pagination.pageSize = val
  handleQuery()
}

const handleCurrentChange = (val) => {
  pagination.page = val
  handleQuery()
}

// 客服面板相关
const isServicePanelOpen = ref(false)

const toggleServicePanel = () => {
  isServicePanelOpen.value = !isServicePanelOpen.value
}

// 页面初始化
onMounted(() => {
  // 设置页面标题和 favicon
  document.title = '51软件下载 - 订单查询'
  let favicon = document.querySelector('link[rel="icon"]')
  if (favicon) {
    favicon.href = '/favicon.ico'
  } else {
    // 如果页面中没有 favicon link 标签，则创建一个
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.href = '/favicon.ico'
    document.head.appendChild(favicon)
  }
})
</script>

<style scoped>
.order-query-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
  padding-bottom: 40px;
}

/* Header Styles */
.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  background: linear-gradient(135deg, #1890ff, #1890ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-menu {
  border: none;
  background: transparent !important;
}

.nav-menu .el-menu-item {
  font-weight: 500;
  padding: 0 20px;
  font-size: 16px;
}

/* Hero Section */
.hero-section {
  padding: 50px 0 40px;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  color: white;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.hero-section .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
}

.hero-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap;
  padding: 40px 20px;
}

.hero-text {
  text-align: center;
  padding: 20px 0;
}

.hero-section h1 {
  font-size: 2.8rem;
  margin-bottom: 15px;
  font-weight: 800;
  line-height: 1.2;
  color: white;
}

.hero-section .lead {
  font-size: 1.1rem;
  margin-bottom: 20px;
  line-height: 1.6;
  opacity: 0.95;
  color: rgba(255, 255, 255, 0.9);
}

/* Query Section */
.query-section {
  max-width: 1200px;
  margin: -40px auto 40px;
  padding: 0 20px;
  position: relative;
  z-index: 10;
}

.query-container {
  background: white;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}

.query-header {
  text-align: center;
  margin-bottom: 30px;
}

.query-header h2 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 8px;
  font-weight: 700;
}

.query-header p {
  color: #666;
  font-size: 0.95rem;
}

.query-form {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 15px;
  flex-wrap: wrap;
}

.query-form .el-form-item {
  margin-bottom: 0;
}

.tel-input {
  width: 300px;
}

.tel-input :deep(.el-input__prefix) {
  color: #1890ff;
}

.query-btn {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border: none;
  padding: 0 40px;
  border-radius: 6px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.query-btn:hover {
  box-shadow: 0 4px 15px rgba(24, 144, 255, 0.3);
  transform: translateY(-2px);
}

.query-btn :deep(.el-icon) {
  margin-right: 6px;
}

/* Result Section */
.result-section {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

.result-header h2 {
  font-size: 1.3rem;
  color: #333;
  margin: 0;
  font-weight: 700;
}

.result-count {
  color: #1890ff;
  font-size: 0.95rem;
  font-weight: 600;
}

.order-table :deep(.el-table__header) {
  background-color: #fafbfc;
}

.order-table :deep(.el-table__header th) {
  background-color: #fafbfc;
  color: #333;
  font-weight: 600;
  border-bottom: 2px solid #e8e8e8;
}

.order-table :deep(.el-table__body tr:hover > td) {
  background-color: #f5f7fa !important;
}

.trade-no {
  /* color: #333; */
  font-weight: 600;
  font-family: 'Courier New', monospace;
  /* font-size: 0.9rem; */
}

.price {
  /* color: #333; */
  font-weight: 600;
  /* font-size: 1rem; */
}

.pagination-wrapper {
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: center;
}

/* No Data */
.no-data {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  padding: 60px 30px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
}

/* 客服联系方式 */
.customer-service {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.service-toggle {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: white;
  padding: 12px 16px;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  font-size: 14px;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.service-toggle:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  box-shadow: 0 6px 24px rgba(24, 144, 255, 0.3);
  transform: translateY(-2px);
}

.service-content {
  background: white;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 180px;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease;
}

.service-content.expanded {
  max-height: 300px;
}

.service-header {
  background: #1890ff;
  color: white;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}

.service-body {
  padding: 15px;
}

.qrcode-container {
  text-align: center;
  margin-bottom: 15px;
}

.qrcode-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.service-info {
  text-align: center;
}

.service-info p {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

.service-link {
  display: inline-block;
  background: #1890ff;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12px;
  margin-top: 5px;
  transition: background 0.3s;
}

.service-link:hover {
  background: #40a9ff;
}

/* Responsive */
@media (max-width: 1024px) {
  .tel-input {
    width: 250px;
  }
  
  .query-btn {
    padding: 0 30px;
  }
}

@media (max-width: 768px) {
  .customer-service {
    display: none;
  }
  
  .hero-section {
    padding: 40px 0 30px;
  }
  
  .hero-section h1 {
    font-size: 2rem;
  }
  
  .hero-section .lead {
    font-size: 0.95rem;
  }
  
  .query-section {
    margin-top: -30px;
  }
  
  .query-container {
    padding: 25px 20px;
  }
  
  .query-header h2 {
    font-size: 1.2rem;
  }
  
  .query-form {
    flex-direction: column;
    width: 100%;
  }
  
  .tel-input {
    width: 100%;
  }
  
  .query-btn {
    width: 100%;
  }
  
  .result-section {
    padding: 20px;
  }
  
  .result-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .order-table :deep(.el-table) {
    font-size: 0.9rem;
  }
  
  .order-table :deep(.el-table__body td) {
    padding: 10px 0;
  }
}

@media (max-width: 480px) {
  .hero-section h1 {
    font-size: 1.5rem;
  }
  
  .result-header h2 {
    font-size: 1.1rem;
  }
  
  .order-table :deep(.el-table__body) {
    font-size: 0.85rem;
  }
}
</style>